import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  border-top: 1px solid #DADADA;
`
export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`
export const Main = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

export const Actions = styled.div`
  display: flex;
  gap: 24px;
`

export const EditButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: #fff;
  color: #028BB7;
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const RegistrationButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: #028BB7;
  color: #fff;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const PetsWrapper = styled.div`
  width: 100%;
`

export const WrapperHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  span {
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    font-weight: 600;
  }
  ${({ type }) => {
    if (type === 'tab') {
      return css`
        border-bottom: 1px solid #DADADA;
        span {
          border-bottom: 2px solid #028BB7;
          background: #FFF;
          color: #028BB7;
          font-weight: 400;
          padding: 8px 16px;
        }
      `
    }
  }}
`

export const Body = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

export const IconWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background: #FFF2EE;
`

export const TitlePets = styled.div`
  color: #222;
  text-align: center;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const SubtitlePets = styled.div`
  color: #555;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const BoxButton = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
